import "./index.scss";

const VARIANT_MAP = {
  active: "active",
  connected: "connected",
  pending: "pending",
  inactive: "inactive",
  disconnected: "disconnected",
  save: "save",
};

function StatusChip({ status, label }) {
  const variant = VARIANT_MAP[status?.toLowerCase()] || "inactive";

  return (
    <span
      className={`status-chip status-chip--${variant}`}
      dangerouslySetInnerHTML={{ __html: label }}
    ></span>
  );
}

export default StatusChip;
